import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box, Alert } from '@mui/material';
import api from '../services/api';
import API from './config';

export default function ProtectedAdminRoute({ children }) {
  const [isAdmin, setIsAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    // Check if user is admin by trying to access admin stats endpoint
    // This will return 403 if not admin, 200 if admin
    api
      .get(`${API}/api/admin/stats`)
      .then(() => {
        setIsAdmin(true);
      })
      .catch((err) => {
        console.error('[ProtectedAdminRoute] Error checking admin status:', err);
        console.error('[ProtectedAdminRoute] Response:', err.response?.data);
        console.error('[ProtectedAdminRoute] Status:', err.response?.status);
        if (err.response?.status === 403) {
          setIsAdmin(false);
          setError('Admin access required');
        } else if (err.response?.status === 401) {
          setError('Authentication required. Please log in again.');
        } else {
          setError(`Failed to verify admin status: ${err.response?.data?.error || err.message || 'Unknown error'}`);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

